import { saveAs } from 'file-saver';

export const downloadFile = (fileData, fileName, mimeType) => {
    const byteCharacters = atob(fileData);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const pdfBlob = new Blob([byteArray], { type: mimeType });

    saveAs(pdfBlob, fileName);
};
